<template>
  <div class="p-5">
    <h2>New Table</h2>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="card p-5">
          <form>

            <div class="mb-3">
              <label for="nameInput">Name</label>
              <input type="text" class="form-control" id="nameInput" placeholder="Name of table" v-model="table.name">
            </div>


            <div class="mb-3">
              <button type="submit" class="btn btn-primary btn-wide" @click.prevent="onSaveClick">Save
              </button>

              <router-link :to="{ name: 'app-editor', params: {id: model.app.id}}"
                           class="btn btn-secondary btn-wide">Cancel</router-link>
            </div>

          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import ModelService from "../../services/ModelService";
  import ArrayUtil from "../../utils/ArrayUtil";

  export default {
    name: 'TableForm',

    data() {
      return {
        model: webase.model,
        service: new ModelService(),
        tableId: null,
        table: {
          name: '',
          app_id: webase.model.app.id
        }
      }
    },
    mounted() {
      if (this.$route.params.id !== undefined) {
        this.tableId = this.$route.params.id

        this.service.get(this.tableId).then((response) => {
          this.table = response
        }).catch((message) => {
          console.log('error loading table')
          console.log(message)
        })

      }
    },
    methods: {

      onSaveClick() {
        let request = {
          model: this.table
        }

        let promise = this.tableId === null ? this.service.create(request) : this.service.update(this.tableId, request)

        promise.then((response) => {

          let savedTable = response

          if( this.tableId === null ) {
            this.model.app.tables.push(savedTable)
          }
          else {
            webase.utils.array.update(this.model.app.tables, savedTable)
          }

          this.$router.push({ name: 'open-app', params: {id: this.model.app.id}})

        }).catch((message) => {
          console.log('error saving model')
          console.log(message)
        })
      }
    }
  }
</script>

